import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HospitableWidget = ({ compact = false, propertyId }) => {
  // Constant Company UUID for your account
  const COMPANY_UUID = "a0ca2a20-5fe6-4c51-a74b-eeef4d02f6b2";
  const location = useLocation();

  // Load the Hospitable Search Script when the component mounts
  useEffect(() => {
    // We only need the script if we are in "Search Mode" (no propertyId provided)
    if (!propertyId) {
      const scriptId = "hospitable-search-widget-script";

      // Prevent loading the script multiple times
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.src =
          "https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js";
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }, [propertyId]);

  // 1. PROPERTY BOOKING WIDGET (Iframe Mode)
  // Used on individual Property Detail pages
  if (propertyId) {
    // OPTION 3 IMPLEMENTATION:
    // Extract query params (dates, guests, pets) from the URL to pre-fill the widget
    const params = new URLSearchParams(location.search);
    const checkin = params.get("checkin");
    const checkout = params.get("checkout");
    const adults = params.get("adults");
    const children = params.get("children");
    const infants = params.get("infants");
    const pets = params.get("pets");

    // Construct the base source URL
    let iframeSrc = `https://booking.hospitable.com/widget/${COMPANY_UUID}/${propertyId}`;

    // Append parameters if they exist
    const queryParts = [];
    if (checkin) queryParts.push(`checkin=${checkin}`);
    if (checkout) queryParts.push(`checkout=${checkout}`);
    if (adults) queryParts.push(`adults=${adults}`);
    if (children) queryParts.push(`children=${children}`);
    if (infants) queryParts.push(`infants=${infants}`);
    if (pets) queryParts.push(`pets=${pets}`);

    if (queryParts.length > 0) {
      iframeSrc += `?${queryParts.join("&")}`;
    }

    return (
      <div className={`w-full overflow-hidden ${compact ? "" : "shadow-md"}`}>
        <iframe
          id="booking-iframe"
          sandbox="allow-top-navigation allow-scripts allow-same-origin"
          style={{ width: "100%", height: "900px", border: "none" }}
          src={iframeSrc}
          title="Hospitable Booking Widget"
        />
      </div>
    );
  }

  // 2. GLOBAL SEARCH WIDGET (Script Mode)
  // Used on the Home Page and Search Page
  return (
    <div className={`w-full mx-auto ${compact ? "" : "py-2"}`}>
      {/* This is the standard widget. 
        It handles the "Guests/Pets" popup automatically.
        It sends users to /search with the correct data in the URL.
      */}
      <hospitable-direct-mps
        identifier="6a29122d-cd8d-4277-90cf-c4717aef8427"
        type="custom"
        results-url="/search"
      ></hospitable-direct-mps>
    </div>
  );
};

export default HospitableWidget;
